export const LOGIN_USER = "LOGIN_USER";
export const EMPTY_USER_STORE = "EMPTY_USER_STORE"